import { put } from 'redux-saga/effects';
import { apiPost } from 'shared/api';
import * as actions from 'store/actions';

export function* fetchRecentPlacesSaga() {
  yield put(actions.fetchRecentPlacesStart());
  try {
    const result = yield apiPost('v2_userRecentLocations', {});
    const recentLocations = result.data.payload.Locations && result.data.payload.Locations.Recent ? result.data.payload.Locations.Recent : [];
    yield put(actions.fetchRecentPlacesSuccess(recentLocations));
  } catch (error) {
    yield put(actions.fetchRecentPlacesFailed(error.response.data.error_message));
  }
}

export function* fetchUserRecentActivitySaga(action) {
  yield put(actions.fetchUserRecentActivityStart(action.Show, action.Page));
  try {
    const data = {
      Page: action.Page ? action.Page : 1,
    };
    if (action.isManagedUser) {
      data.UserId = action.UserId;
    }
    if (action.Show) {
      data.Show = action.Show;
    }
    if (action.PageSize) {
      data.PageSize = action.PageSize;
    }
    const result = yield apiPost('v2_userRecentActivity', data);
    const recentActivity = result.data.payload.Recent ? result.data.payload.Recent : [];
    yield put(actions.fetchUserRecentActivitySuccess(recentActivity, result.data.payload.Showing));
  } catch (error) {
    yield put(actions.fetchUserRecentActivityFailed(error.response.data.error_message));
  }
}
